/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import $ from 'jquery';
import React, { Component, ComponentType } from 'react';
import {
    ICell, IRow, ITableCellComponentProps, RowType
} from '../types/tableVisualizationTypes';
import { ILinkToRefObjectPair } from '../../types/commonTypes';
import { ILinkOptions } from '../../../../store/types/StateTypes';
import eventTypeToApiMethod from '../../../enums/eventTypeToApiMethod';

interface ITableRowComponentProps {
    row: IRow,
    relativeIndex: number,
    linkToRefObjectPairs: ILinkToRefObjectPair[],
    linkOptions: ILinkOptions
}

export default function TableRowComponentHOC(Cell: ComponentType<ITableCellComponentProps>) {

    return class TableRowComponent extends Component<ITableRowComponentProps> {

        hyperlinkEventListener = (event: React.MouseEvent<HTMLDivElement>) => {
            const {
                row,
                linkOptions
            } = this.props;

            if (!linkOptions || !linkOptions.events) {
                return;
            }

            const found = _.find(eventTypeToApiMethod, (type) => {
                return _.includes(type.eventTypes, event.type);
            });
            if (!found) {
                return;
            }
            const { apiMethod } = found;

            const callback = linkOptions.events[apiMethod];
            if (!callback) {
                return;
            }

            let tdCell = $(event.target);
            if (tdCell.prop('tagName').toLowerCase() !== 'td') {
                tdCell = $(event.target).parents('td');
            }
            const cellIndex = tdCell.data('cell-index');
            if (_.isUndefined(cellIndex)) {
                return;
            }

            const { cells } = row;
            const cell = cells[cellIndex];

            const $Event = new $.Event((event as unknown) as string);

            callback.call(event.nativeEvent.target, $Event, cell.linkData, null, cell.tableLink);
        }

        render() {
            const {
                row,
                relativeIndex,
                linkToRefObjectPairs,
            } = this.props;

            const { cells, index, height } = row;
            const eventListener = this.hyperlinkEventListener;

            const baseClasses = 'jr-mDatatable-row jr';

            const cellNodes = cells.map((cell: ICell, cellIndex) => {
                const ref = React.createRef();
                if (!row.isLoading) {
                    linkToRefObjectPairs.push({ data: cell.linkData, ref });
                }
                return (
                    <Cell
                        cellRef={ref}
                        key={cell.id}
                        width={cell.width}
                        title={cell.label}
                        aggregationLabel={cell.aggregationLabel}
                        contentType={cell.contentType}
                        colSpan={cell.collSpan}
                        eventListener={eventListener}
                        cellIndex={cellIndex}
                    />
                );
            });

            let className = baseClasses;
            if (row.rowType === RowType.DETAIL) {
                className = `${baseClasses} ${relativeIndex % 2 ? 'jr-mDatatable-rowOdd' : 'jr-mDatatable-rowEven'}`;
            } else if (row.rowType === RowType.GROUP) {
                className = `${baseClasses} jr-mDatatable-rowGroup`;
            } else if (row.rowType === RowType.GROUP_TOTAL) {
                className = `${baseClasses} jr-mDatatable-rowGrouptotal`;
                return (
                    <tr
                        className={className}
                        tabIndex={-1}
                        data-absolute-index={index}
                        data-relative-index={relativeIndex}
                        data-fielddisplay={row.fieldDisplay}
                        style={{ height: (height === -1 ? 'auto' : height) }}
                    >
                        {cellNodes}
                    </tr>
                );
            }

            return (
                <tr
                    className={className}
                    tabIndex={-1}
                    data-absolute-index={index}
                    data-relative-index={relativeIndex}
                    style={{ height: (height === -1 ? 'auto' : height) }}
                >
                    {cellNodes}
                </tr>
            );
        }
    }
}
